import { PurchasableFragments } from '@/apollo/fragments/purchasable';
import { Field } from '@/form/decorators/Field';
import { Form } from '@/form/decorators/Form';
import GraphQLForm from '@/form/GraphQLForm';
import { Passport } from '@/types/api';
import gql from 'graphql-tag';

@Form({
  apollo: {
    mutation: gql`
      mutation UpdatePassport($input: UpdatePassportInput!) {
        updatePassport(input: $input) {
          passport {
            ...Purchasable
          }
        }
      }
      ${PurchasableFragments.Purchasable}
    `,
  },
})
export class UpdatePassportForm extends GraphQLForm<Passport> {
  @Field({
    static: true,
  })
  public readonly id: string;

  @Field()
  public title: string;

  @Field()
  public description: string;

  @Field()
  public price: number;

  @Field()
  public images: Array<File> | null = null;

  @Field()
  public shopifyIdEU: string | null = null;

  @Field()
  public shopifyIdUS: string | null = null;

  @Field()
  public videoFileKey: string | null = null;

  constructor(passport: Passport) {
    super(passport);
    this.id = passport.id;
    this.title = passport.title;
    this.description = passport.description;
    this.price = passport.price;
    this.shopifyIdEU = passport.variant?.shopifyIdEU ?? null;
    this.shopifyIdUS = passport.variant?.shopifyIdUS ?? null;
    this.videoFileKey = passport.video?.fileKey ?? null;
  }
}
